
import { BASE_URL } from "../ApiService/ApiConfig.js";

const API_URL = `${BASE_URL}/nomina/empleado`;

const obtenerConfig = () => {
    // Manejo seguro del token para evitar errores si es null
    const tokenRaw = localStorage.getItem('jwt');
    const token = tokenRaw ? tokenRaw.replaceAll('"', '') : '';

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: 'Bearer ' + token
        }
    };
}

// 1. OBTENER TODOS LOS EMPLEADOS
// Backend: GET /opem-service/empleado
export const obtenerEmpleados = async () => {
    try {
        const response = await fetch(API_URL, {
            method: 'GET',
            ...obtenerConfig()
        });

        if (!response.ok) throw new Error('Error al obtener empleados');
        return await response.json();
    } catch (error) {
        console.error('Error en obtenerEmpleados:', error);
        throw error;
    }
}

// 2. BUSCAR POR IDENTIFICADOR (Cédula/DNI)
// Backend: GET /opem-service/empleado/identificador/{identificador}
// Nota: Tu backend NO tiene endpoint por ID numérico (Long), solo por String identificador.
export const obtenerEmpleadoPorIdentificador = async (identificador) => {
    try {
        const response = await fetch(`${API_URL}/identificador/${identificador}`, {
            method: 'GET',
            ...obtenerConfig()
        });

        if (!response.ok) throw new Error('Error al obtener empleado por identificación');
        return await response.json();
    } catch (error) {
        console.error('Error en obtenerEmpleadoPorIdentificador:', error);
        throw error;
    }
}

export const crearEmpleado = async (empleadoData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: obtenerConfig().headers,
            body: JSON.stringify(empleadoData)
        });

        if (!response.ok) throw new Error('Error al crear empleado');

        // Retorna el objeto creado (incluyendo el nuevo ID)
        return await response.json();
    } catch (error) {
        console.error('Error en crearEmpleado:', error);
        throw error;
    }
}

export const actualizarEmpleado = async (empleadoId, empleadoData) => {
    try {

        const payload = {
            ...empleadoData,
            empleadoId: empleadoId
        };

        const response = await fetch(API_URL, {
            method: 'PUT',
            headers: obtenerConfig().headers,
            body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Error al actualizar empleado');
        return await response.json();
    } catch (error) {
        console.error('Error en actualizarEmpleado:', error);
        throw error;
    }
}


export const eliminarEmpleado = async (empleadoId) => {
    try {
        const config = obtenerConfig();
        const response = await fetch(`${API_URL}/${empleadoId}`, {
            method: 'DELETE',
            headers: config.headers
        });

        if (response.status === 204 || response.ok) {
            return true;
        }

        const errorMsg = await response.text();
        throw new Error(errorMsg || 'Error al eliminar empleado');
    } catch (error) {
        console.error('Error en eliminarEmpleado:', error);
        throw error;
    }
}
